module.exports = __webpack_public_path__ + "img/pump-soap.a378107e.svg";